@use "../../styles/mixins/component-wrapper" as wrapper;

@include wrapper.layered-component {
  .headline-6xl,
  .headline-5xl,
  .headline-4xl,
  .headline-3xl,
  .headline-2xl,
  .headline-xl,
  .headline-l,
  .headline-m,
  .headline-s {
    color: var(--semantic-color-on-surface-primary-resting);
    font-style: normal;

    /* VARIANT */
    &.primary {
      color: var(--semantic-color-on-surface-primary-resting);

      /* INVERSE (Negative Region / Context Based) */
      &.inverse {
        color: var(--semantic-color-on-surface-primary-inverse-resting);
      }
    }

    &.secondary {
      color: var(--semantic-color-on-surface-secondary-resting);

      /* INVERSE (Negative Region / Context Based) */
      &.inverse {
        color: var(--semantic-color-on-surface-secondary-inverse-resting);
      }
    }

    /* ACCENT */
    em {
      font-style: normal;
    }

    &.headline-accent--yellow em {
      color: var(--semantic-color-accent-attention-yellow-resting);
    }

    &.headline-accent--orange em {
      color: var(--semantic-color-accent-attention-orange-resting);
    }

    &.headline-accent--red em {
      color: var(--semantic-color-accent-attention-red-resting);
    }

    &.headline-accent--purple em {
      color: var(--semantic-color-accent-attention-purple-resting);
    }

    &.headline-accent--aqua em {
      color: var(--semantic-color-accent-attention-aqua-resting);
    }

    &.headline-accent--blue em {
      color: var(--semantic-color-accent-attention-blue-resting);
    }

    &.headline-accent--teal em {
      color: var(--semantic-color-accent-attention-teal-resting);
    }

    &.headline-accent--green em {
      color: var(--semantic-color-accent-attention-green-resting);
    }

    &.inverse {
      color: var(--semantic-color-action-primary-inverse-resting);

      &.headline-accent--yellow em {
        color: var(--semantic-color-accent-attention-inverse-yellow-resting);
      }

      &.headline-accent--orange em {
        color: var(--semantic-color-accent-attention-inverse-orange-resting);
      }

      &.headline-accent--red em {
        color: var(--semantic-color-accent-attention-inverse-red-resting);
      }

      &.headline-accent--purple em {
        color: var(--semantic-color-accent-attention-inverse-purple-resting);
      }

      &.headline-accent--aqua em {
        color: var(--semantic-color-accent-attention-inverse-aqua-resting);
      }

      &.headline-accent--blue em {
        color: var(--semantic-color-accent-attention-inverse-blue-resting);
      }

      &.headline-accent--teal em {
        color: var(--semantic-color-accent-attention-inverse-teal-resting);
      }

      &.headline-accent--green em {
        color: var(--semantic-color-accent-attention-inverse-green-resting);
      }
    }
  }

  /* SIZES */
  .headline-6xl {
    font: var(--semantic-text-headline-6xl);
    letter-spacing: var(--semantic-letter-spacing-headline-6xl);
  }

  .headline-5xl {
    font: var(--semantic-text-headline-5xl);
    letter-spacing: var(--semantic-letter-spacing-headline-5xl);
  }

  .headline-4xl {
    font: var(--semantic-text-headline-4xl);
    letter-spacing: var(--semantic-letter-spacing-headline-4xl);
  }

  .headline-3xl {
    font: var(--semantic-text-headline-3xl);
    letter-spacing: var(--semantic-letter-spacing-headline-3xl);
  }

  .headline-2xl {
    font: var(--semantic-text-headline-2xl);
    letter-spacing: var(--semantic-letter-spacing-headline-2xl);
  }

  .headline-xl {
    font: var(--semantic-text-headline-xl);
    letter-spacing: var(--semantic-letter-spacing-headline-xl);
  }

  .headline-l {
    font: var(--semantic-text-headline-l);
    letter-spacing: var(--semantic-letter-spacing-headline-l);
  }

  .headline-m {
    font: var(--semantic-text-headline-m);
    letter-spacing: var(--semantic-letter-spacing-headline-m);
  }

  .headline-s {
    font: var(--semantic-text-headline-s);
    letter-spacing: var(--semantic-letter-spacing-headline-s);
  }

  /* FOCUS STATE */
  &:focus {
    outline: var(--semantic-border-width-focus) solid var(--semantic-color-border-focus);
    outline-offset: var(--semantic-spacing-focus-offset);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
  }
}
